<template>
  <div class="whv100 posr">
    <div class="mainStyle whv100">
      <bg class="whv100" style="z-index:-1" @isPc='isPc'></bg>
      <div class="contain" style="z-index:1">
        <img :src="logoImg">
        <img
          id="btn1"
          src="@/assets/img/btn1.png"
          @click="openWeChat"
          class="button"
          @mouseenter="mEnter"
          @mouseleave="mLeave"
        >
      </div>
      <div class="btn" style="z-index:1">
        <img
          id="btn2"
          @click="openWin"
          src="@/assets/img/btn3.png"
          class="button"
          @mouseenter="mEnter2"
          @mouseleave="mLeave2"
        >
        <img
          id="btn3"
          @click="openURL"
          src="@/assets/img/btn2.png"
          class="button"
          @mouseenter="mEnter3"
          @mouseleave="mLeave3"
        >
      </div>
    </div>

    <div id="mask"></div>
    <div class="contain" v-if="show" style="z-index:999" @click.stop="closeWin">
      <transition name="fade" mode="out-in" appear>
        <img v-if="showWeChat" src="@/assets/img/code.png">
        <img v-if="showApp" src="@/assets/img/code2.png">
      </transition>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "mainPage",
  data() {
    return {
      show: false,
      showApp: false,
      showWeChat: false,
      pc:true,
      logoImg:'',
      url: "https://weibo.com/u/6100531209?topnav=1&wvr=6&topsug=1"
    };
  },

  mounted() {
    // //初始化视频方法
    for (var i in document.getElementsByTagName("img")) {
      try {
        document.getElementsByTagName("img")[i].onmousedown = function(e) {
          e.preventDefault();
        };
      } catch (error) {
      }
    }
  },
  methods: {
    closeWin() {
      this.show = false;
      this.showApp = false;
      this.showWeChat = false;
    },
    openWin() {
      this.show = true;
      this.showApp = true;
    },
    openWeChat() {
      this.showWeChat = true;
      this.show = true;
    },
    openURL() {
      window.open(this.url, "_blank");
    },
    mEnter() {
      document.getElementById("btn1").style.opacity = 1;
    },
    mLeave() {
      document.getElementById("btn1").style.opacity = 0.6;
    },
    mEnter2() {
      document.getElementById("btn2").style.opacity = 1;
    },
    mLeave2() {
      document.getElementById("btn2").style.opacity = 0.6;
    },
    mEnter3() {
      document.getElementById("btn3").style.opacity = 1;
    },
    mLeave3() {
      document.getElementById("btn3").style.opacity = 0.6;
    },
    isPc(data){
      if(data==true){
        this.logoImg = require("@/assets/img/logo.png")
      }else{
        this.logoImg = require("@/assets/img/logo_app.png")
      }
      
    }
  }
};
</script>

<style scoped>
.mainStyle {
  height: 100vh;
  width: 100%;
}
.contain {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.btn {
  position: absolute;
  top: 0;
  right: 0;
  padding-top: 10px;
  padding-right: 10px;
}

#mask {
  height: 100vh;
  width: 100%;
  opacity: 0.2;
  background-color: black;
  bottom: 0;
  left: 0;
  top: 0;
  position: absolute;
  z-index: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(40px);
}
.button {
  opacity: 0.6;
}
</style>


// WEBPACK FOOTER //
// src/components/main.vue